export default __webpack_public_path__ + "static/media/color-07.03ec289f.svg";